export const name = "JSON_EXTRACT";
export const summary = `(Deprecated) Extracts a JSON value and converts it to a SQL JSON-formatted \`STRING\` or \`JSON\` value.`;
export const reference = `
## JSON_EXTRACT

(Deprecated) Extracts a JSON value and converts it to a SQL JSON-formatted \`STRING\` or \`JSON\` value.



### JSON_EXTRACT(json_string_expr, json_path)



\`\`\`
JSON_EXTRACT(json_expr, json_path)
\`\`\`


### Description

Extracts a JSON value and converts it to a SQL JSON-formatted \`STRING\` or \`JSON\` value. This function uses single quotes and brackets to escape invalid JSONPath characters in JSON keys. For example: \`['a.b']\`.

Arguments:

- \`json_string_expr\`: A JSON-formatted string. For example:

- \`json_expr\`: JSON. For example:

- \`json_path\`: The JSONPath. This identifies the data that you want to obtain from the input.

There are differences between the JSON-formatted string and JSON input types. For details, see Differences between the JSON and JSON-formatted STRING types.


### Return type

- \`json_string_expr\`: A JSON-formatted \`STRING\`
- \`json_expr\`: \`JSON\`


### Examples

In the following example, JSON data is extracted and returned as JSON.



\`\`\`
SELECT
  JSON_EXTRACT(JSON '{"class": {"students": [{"id": 5}, {"id": 12}]}}', '$.class')
  AS json_data;

/*-----------------------------------*
 | json_data |
 +-----------------------------------+
 | {"students":[{"id":5},{"id":12}]} |
 *-----------------------------------*/
\`\`\`

In the following examples, JSON data is extracted and returned as JSON-formatted strings.



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "Jane"}]}}',
  '$') AS json_text_string;

/*-----------------------------------------------------------*
 | json_text_string |
 +-----------------------------------------------------------+
 | {"class":{"students":[{"name":"Jane"}]}} |
 *-----------------------------------------------------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": []}}',
  '$') AS json_text_string;

/*-----------------------------------------------------------*
 | json_text_string |
 +-----------------------------------------------------------+
 | {"class":{"students":[]}} |
 *-----------------------------------------------------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "John"}, {"name": "Jamie"}]}}',
  '$') AS json_text_string;

/*-----------------------------------------------------------*
 | json_text_string |
 +-----------------------------------------------------------+
 | {"class":{"students":[{"name":"John"},{"name":"Jamie"}]}} |
 *-----------------------------------------------------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "Jane"}]}}',
  '$.class.students[0]') AS first_student;

/*-----------------*
 | first_student |
 +-----------------+
 | {"name":"Jane"} |
 *-----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": []}}',
  '$.class.students[0]') AS first_student;

/*-----------------*
 | first_student |
 +-----------------+
 | NULL |
 *-----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "John"}, {"name": "Jamie"}]}}',
  '$.class.students[0]') AS first_student;

/*-----------------*
 | first_student |
 +-----------------+
 | {"name":"John"} |
 *-----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "Jane"}]}}',
  '$.class.students[1].name') AS second_student;

/*----------------*
 | second_student |
 +----------------+
 | NULL |
 *----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": []}}',
  '$.class.students[1].name') AS second_student;

/*----------------*
 | second_student |
 +----------------+
 | NULL |
 *----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "John"}, {"name": null}]}}',
  '$.class.students[1].name') AS second_student;

/*----------------*
 | second_student |
 +----------------+
 | NULL |
 *----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "John"}, {"name": "Jamie"}]}}',
  '$.class.students[1].name') AS second_student;

/*----------------*
 | second_student |
 +----------------+
 | "Jamie" |
 *----------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "Jane"}]}}',
  "$.class['students']") AS student_names;

/*------------------------------------*
 | student_names |
 +------------------------------------+
 | [{"name":"Jane"}] |
 *------------------------------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": []}}',
  "$.class['students']") AS student_names;

/*------------------------------------*
 | student_names |
 +------------------------------------+
 | [] |
 *------------------------------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(
  '{"class": {"students": [{"name": "John"}, {"name": "Jamie"}]}}',
  "$.class['students']") AS student_names;

/*------------------------------------*
 | student_names |
 +------------------------------------+
 | [{"name":"John"},{"name":"Jamie"}] |
 *------------------------------------*/
\`\`\`



\`\`\`
SELECT JSON_EXTRACT('{"a": null}', "$.a"); -- Returns a SQL NULL
SELECT JSON_EXTRACT('{"a": null}', "$.b"); -- Returns a SQL NULL
\`\`\`



\`\`\`
SELECT JSON_EXTRACT(JSON '{"a": null}', "$.a"); -- Returns a JSON 'null'
SELECT JSON_EXTRACT(JSON '{"a": null}', "$.b"); -- Returns a SQL NULL
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
